import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHourglass = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.03794 5.47799C6.59394 8.68699 8.54794 10.885 11.9999 12C15.4519 10.885 17.4059 8.68699 17.9619 5.47799C17.9949 5.26354 17.981 5.04449 17.9211 4.83594C17.8612 4.6274 17.7568 4.43433 17.6151 4.27005C17.4733 4.10578 17.2976 3.97421 17.1001 3.88442C16.9026 3.79464 16.6879 3.74877 16.4709 3.74999H7.52894C7.31197 3.74877 7.09732 3.79464 6.89979 3.88442C6.70227 3.97421 6.52657 4.10578 6.38483 4.27005C6.24309 4.43433 6.13867 4.6274 6.07878 4.83594C6.01889 5.04449 6.00496 5.26354 6.03794 5.47799V5.47799Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 0.75H20.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.52903 20.25C7.31216 20.2512 7.09761 20.2054 6.90016 20.1156C6.70272 20.0259 6.52708 19.8944 6.38535 19.7303C6.24363 19.5661 6.13918 19.3732 6.07922 19.1647C6.01926 18.9563 6.00521 18.7374 6.03803 18.523C6.59403 15.314 8.54803 13.116 12 12C15.452 13.116 17.406 15.314 17.962 18.523C17.9949 18.7374 17.9808 18.9563 17.9208 19.1647C17.8609 19.3732 17.7564 19.5661 17.6147 19.7303C17.473 19.8944 17.2973 20.0259 17.0999 20.1156C16.9025 20.2054 16.6879 20.2512 16.471 20.25H7.52903Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 23.25H20.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHourglass.displayName = 'SvgHourglass';
export default SvgHourglass;
